export const DATA = {
  DAILY: "Almost every day",
  WEEKLY: "Several times per week",
  MONTHLY: "Several times per month",
  NEVER: "Never",
};
